import { render } from "./TextareaInput.vue?vue&type=template&id=5d310716"
import script from "./TextareaInput.vue?vue&type=script&setup=true&lang=js"
export * from "./TextareaInput.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/TextareaInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d310716"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d310716', __exports__)) {
    api.reload('5d310716', __exports__)
  }
  
  module.hot.accept("./TextareaInput.vue?vue&type=template&id=5d310716", () => {
    api.rerender('5d310716', render)
  })

}


export default __exports__